import { formatDateTime, timeAgoWithOutSeconds } from "utils/formatter"
import { TicketContext } from "../TicketContext"
import { useContext, useMemo } from "react"
import { keyBy } from "lodash"
import { requestTypeOptions } from "keys/requestTypes"

const useTicketDetails = () => {
    const { ticket } = useContext(TicketContext)
    const { ticket_type, created_by_name, update_date, create_date } = ticket.data || {}

    const requestTypeKeys = keyBy(requestTypeOptions, "id")

    const ticketDetails = useMemo(
        () => [
            {
                label: "מאת",
                value: created_by_name
            },
            {
                label: "פניה מסוג",
                value: requestTypeKeys[ticket_type]?.name
            },
            {
                label: "תאריך פתיחה",
                value: formatDateTime(create_date)
            },
            {
                label: "עודכן לאחרונה",
                value: timeAgoWithOutSeconds(update_date)
            }
        ], [ticket.data]
    )

    return ticketDetails
}

export default useTicketDetails